import questionControlsWithCompanyFragilties from './questionControlsWithCompanyFragilties'

const helpers = { questionControlsWithCompanyFragilties }

export default helpers
